// src/utils/pageMeta.js
// SPA 라우트별 메타데이터(title/description/canonical/OG/JSON-LD) 동적 설정.
// AdSense/SEO 크롤러가 각 페이지를 고유 문서로 인식하도록 돕는다.
import { useEffect } from "react";

const SITE = "펫말";
const ORIGIN = "https://www.petmal.kr";
const DEFAULT_TITLE = "펫말 - 반려동물이 전하는 편지 🐾";
const DEFAULT_DESC =
  "말 못 하는 게 아니라, 말할 기회가 없었던 거예요. 반려동물과의 추억을 들려주시면, 그 친구의 마음을 편지로 전해드립니다.";

function upsertMeta(key, content, attr = "name") {
  if (content == null) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export function usePageMeta({ title, description, canonicalPath, jsonLd } = {}) {
  const jsonLdStr = jsonLd ? JSON.stringify(jsonLd) : null;
  useEffect(() => {
    const fullTitle = title ? `${title} | ${SITE}` : DEFAULT_TITLE;
    const desc = description || DEFAULT_DESC;
    const path =
      canonicalPath ||
      (typeof window !== "undefined" ? window.location.pathname : "/");
    const canonical = ORIGIN + (path === "/" ? "/" : path);

    document.title = fullTitle;
    upsertMeta("description", desc);
    upsertMeta("og:title", fullTitle, "property");
    upsertMeta("og:description", desc, "property");
    upsertMeta("og:url", canonical, "property");
    upsertCanonical(canonical);

    let script = null;
    if (jsonLdStr) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.setAttribute("data-page-jsonld", "true");
      script.textContent = jsonLdStr;
      document.head.appendChild(script);
    }

    return () => {
      if (script && script.parentNode) script.parentNode.removeChild(script);
    };
  }, [title, description, canonicalPath, jsonLdStr]);
}
